export default {
  有效交易量达标即可获得:`Rewards will be granted upon meeting the effective trading volume threshold. Please refer to the <a href="#pay-session5">programme guidelines</a> for details. `,
  交易领薪计划: "Enjoy Monthly Payouts ",
  为了鼓励交易者提升交易水平:`Grow Your Followers and Gain Up to <span class="red">18<span class="sRed">%</span></span> p.a.`,
  加入交易社区:
    " The rewards are designed specifically for exceptional traders. Monthly rewards are based on the number of followers and total AUM, with reward rates reaching up to 18% per year. ",
  即刻发起交易信号: "Send trading signals publicly",
  无限奖励月月拿: "Get paid monthly ",
  优享11个专属大礼: "Enjoy 10 exclusive privileges",
  即刻加入: "Join Now",
  交易员等级奖励机制: `Trader Reward Levels`,
  EBC基于跟随人数和资金提供五档奖励:
    "EBC offers five reward tiers based on the number of followers and total AUM.",
  "/月": "/per month",
  精英交易员: "Elite",
  管理资金量: "AUM",
  跟随账户数: "Followers",
  大师交易员: "Master",
  冠军交易员: "Champion",
  明星交易员: "All Star",
  资金管理费: "1% Management Fee",
  传奇交易员: "Legend",
  多层次的增值服务: "Multi-Tiered Value-Added Services",
  EBC提供多达11项增值服务:
    "We offer up to 10 value-added services, integrating traffic and media resources to comprehensively enhance the trader's signal influence.",
  "精英/大师交易员": "Elite/Master",
  "7×24小时优先客服": "24/7 Customer Service",
  金融投资经典书籍礼遇: "Free Investment Book Collection",
  专属VPS赞助: "Exclusive VPS Sponsorship",
  订单流软件1年使用权: "1-Year Access to Order Flow Software",
  EBC定制大礼包: "EBC Premium Gift Set",
  信号优先置顶展示: "Provider Display",
  受邀参观海外办公室: "Invitation to Visit International Offices",
  巴萨球星联名礼包: "FC Barcelona Star Player Gift Collection",
  巴萨赛场传奇之旅: "Legendary Barcelona Stadium Experience",
  品牌战略合作: "Strategic Brand Partnership",
  全球金融资源管家服务: "Global Financial Resource Management Services",
  五维指标评价系统: "Five-Dimensional Indicator Evaluation System",
  为交易员信号提供公开透明的评估:
    "Provides an open and transparent evaluation of copy trading signal providers' performance, showcasing trading style, increasing visibility, and attracting more followers.",
  收益率: "Rate of Return ",
  历史收益率: "Historical return rate; the higher, the better.",
  最大回撤: "Maximum Drawdown",
  衡量风控能力: "Measures risk control capability; the lower, the better.",
  获利系数: "Profit Coefficient",
  利润因子: "Profit factor; the higher, the stronger the profitability.",
  夏普比率: "Sharpe Ratio",
  每份风险的收益: "Returns per unit of risk; the higher, the better.",
  标准差: "Standard Deviation",
  收益波动率: "Measures volatility; the lower, the more stable.",
  以上数据仅供参考: "*The above data is for reference only.",
  活动须知: "Programme Guidelines",
  list: [
    {
      label: "1. Follower Definitions",
      value: [
        {label:'Follower Capital = Account Balance ÷ Number of followed Provider',value:[]},
        {label:'Follower Limit: Each account can follow up to 10 providers simultaneously.',value:[]},
        {label:'Valid Follower Account: An account is considered valid if its follower capital is at least $500. Accounts with less than $500 will not be counted as valid follower accounts and will not be included in the total follower capital.',value:[]},
        {label:'Valid Follower User: If multiple valid accounts under the same EBC user follow the same trader (provider), they are counted as one valid follower user.',value:[]},
        {label:'AUM(Assets Under Management):Total Follower Capital + Trader’s (Provider Account) Balance',value:[]},
        // {label:'Data Exclusion: Accounts under the trader that subscribe to their own account are excluded from both valid Followed user count and Followed capital.',value:[]}
      ],
    },
    {
      label: "2. Level Activation & Reward Criteria",
      value: [
        {label:'Level Activation:',value:['The system evaluates every hour. If both AUM and Valid Follower User Count meet the requirements of a particular level, that level is considered activated.']},
        {label:'Reward Criteria (all conditions must be met):',value:['The trader must maintain the required level on every calendar day of the month.',{innerLabel:'Effective Trading Volume (lot)≥ Trader’s (Provider Account) Daily Average Balance × 0.2%:',innerValue:['Effective Trading Volume = Total Closed Volume for the Month + Net Open Positions (Net Open Positions = Total Open Volume − Hedging Positions in the Same Symbol)','Daily Average Balance = Sum of Trader’s Daily Balances ÷ Number of Calendar Days in the Month','US stocks and ETFs are excluded from the effective trading volume calculation.']}]},
        {label:'Bonus Calculation & Distribution',value:['Daily Average AUM = Sum of Daily AUM ÷ Number of Calendar Days in the Month','Monthly Bonus = (Daily Average AUM × Management Fee Rate) ÷ 12','All rewards are credited to the trading account and can be withdrawn freely.','Participation is limited to genuine and valid clients. EBC reserves the final interpretation rights of the event rules and the definition of valid clients.']}
      ],
    }
  ],
  年化资金管理费: "Annual Rewards",
};
